// Per-tour access grant tokens for password-protected tours. The token is minted
// server-side by unlock_tour() after a correct password and lets the viewer read
// the protected tour's scene graph via tour_view_graph(). Session-scoped: clears
// on tab close, so a shared machine doesn't leak access across sessions.
const key = (tourId: string) => `tour_grant_${tourId}`;

export function setTourGrant(tourId: string, token: string): void {
  sessionStorage.setItem(key(tourId), token);
}

export function getTourGrant(tourId: string): string | null {
  return sessionStorage.getItem(key(tourId));
}
